// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"read-only-tag-pills_tagWrapper_mAE","pillViewer":"read-only-tag-pills_pillViewer_2FV","pillViewerWithIcons":"read-only-tag-pills_pillViewerWithIcons_WeJ"};